import React, { useState } from "react";
import { Button, TextField } from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import CloseIcon from "@mui/icons-material/Close";
import DatePickerWithTimeComponent from "../DatePickerWithTimeComponent";
import { doc, serverTimestamp, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { useAuth } from "../../contexts/AuthContext";
import { showCustomToast } from "../Misc/CustomToast";
import "./EditQuickNoteRedesign.css";

function EditQuickNote(props) {
  const { currentUser } = useAuth();

  const [quickNoteText, setQuickNoteText] = useState(props.note);
  const [effectiveDateTime, setEffectiveDateTime] = useState(
    props.effectiveDate
  );
  const [isLoading, setIsLoading] = useState(false);
  const [hasChanged, setHasChanged] = useState(false);

  const handleDateTimeChange = (event) => {
    setHasChanged(true);
    setEffectiveDateTime(event);
  };

  const handleUpdateQuickNote = async (note, noteId, effectiveDateTime) => {
    const noteData = {
      noteContent: note,
      updateAt: serverTimestamp(),
      effectiveDateTime: effectiveDateTime,
      doneBy: currentUser.displayName,
    };

    if (quickNoteText && effectiveDateTime) {
      setIsLoading(true);
      try {
        const noteRef = doc(db, "notes", noteId);
        await updateDoc(noteRef, noteData);
        showCustomToast("Note successfully updated!", "success");

        setIsLoading(false);
        props.closemodal();
      } catch (error) {
        console.log("error updating note :", error);
        showCustomToast("Problem when updating note", "error");
      }
    } else {
      showCustomToast("Some mandatory fields are empty. Please check.", "error");
    }
  };

  const handleSubmit = () => {
    handleUpdateQuickNote(quickNoteText, props.noteId, effectiveDateTime);
  };

  const handleChange = (event) => {
    setHasChanged(true);
    setQuickNoteText(event.target.value);
  };

  return (
    <div className="edit-quick-note-modal">
      <div className="edit-quick-note-header">
        <div>
          <h2>Edit quick note</h2>
          <p>Update the note content and effective date.</p>
        </div>
        <button
          type="button"
          className="edit-quick-note-close"
          onClick={props.closemodal}
          aria-label="Close edit quick note modal"
        >
          <CloseIcon fontSize="small" />
        </button>
      </div>

      <div className="edit-quick-note-body">
        <section className="edit-quick-note-section">
          <div className="edit-quick-note-section-title">
            <span>Note details</span>
          </div>

          <div className="edit-quick-note-textarea">
            <div className="edit-quick-note-label">
              Note content <span>*</span>
            </div>
            <TextField
              name="quickNote"
              value={quickNoteText}
              onChange={handleChange}
              placeholder="Type quick session note here"
              multiline
              rows={11}
              fullWidth
            />
          </div>

          <div className="edit-quick-note-date-row">
            <DatePickerWithTimeComponent
              title="Effective date and time"
              value={effectiveDateTime}
              onChange={handleDateTimeChange}
            />
          </div>
        </section>
      </div>

      <div className="edit-quick-note-footer">
        <Button
          variant="outlined"
          className="edit-quick-note-cancel"
          onClick={props.closemodal}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          className="edit-quick-note-save"
          disabled={!hasChanged || isLoading}
          onClick={handleSubmit}
        >
          {isLoading ? "Updating..." : "Update note"}
        </Button>
      </div>
    </div>
  );
}

export default EditQuickNote;
